import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-grey-6" }, " Trashed persons can be restored later. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Trash Person",
    ref: "modal",
    size: "xs"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_q_btn, {
        label: "Cancel",
        flat: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hide()))
      }),
      _createVNode(_component_async_btn, {
        label: "Trash",
        color: "negative",
        icon: "fa fa-trash",
        task: _ctx.task,
        onClick: _ctx.trashPerson
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.person)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, [
              _createTextVNode(" Move "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.person.label || 'this person'), 1),
              _createTextVNode(" to trash? ")
            ]),
            _hoisted_2
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}